<template>
    <div class="loader-layout" data-cy="loader-layout">
        <a-spin size="large" data-cy="loader-layout-spinner" />
        <slot v-if="$route.path === '/logout'" />
    </div>
</template>
